import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from '../../../components/ui/LanguageSelector';
import { translateStaticText } from '../../../config/staticAssessmentTranslations';

const sections = [
  { icon: '🔢', name: 'Quantitative Aptitude' },
  { icon: '🧩', name: 'Logical Reasoning' },
  { icon: '📝', name: 'Verbal Ability' },
  { icon: '📊', name: 'Data Interpretation' },
  { icon: '🔷', name: 'Abstract Reasoning' }
];

export default function IntroPage() {
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState('en');

  const displaySections = sections.map((section) => ({
    ...section,
    name: translateStaticText(section.name, currentLanguage),
    questionCountLabel: translateStaticText('10 questions', currentLanguage)
  }));

  return (
    <div className="min-h-screen aptitude-intro-bg px-4 py-12 flex items-center justify-center">
      <div className="w-full max-w-3xl text-center">
        <div className="flex justify-end mb-4">
          <LanguageSelector
            currentLanguage={currentLanguage}
            onLanguageChange={setCurrentLanguage}
            isTranslating={false}
          />
        </div>
        <h1 className="font-sora text-4xl md:text-5xl text-white aptitude-fade-in">{translateStaticText('MindEdge Aptitude Test', currentLanguage)}</h1>
        <p className="mt-3 text-white/75">{translateStaticText('5 Sections · 50 Questions · ~45 minutes', currentLanguage)}</p>

        <div className="mt-10 grid gap-3 max-w-2xl mx-auto">
          {displaySections.map((section, index) => (
            <div
              key={`${index}_${section.icon}`}
              className="aptitude-intro-item rounded-xl border border-white/20 bg-white/10 backdrop-blur-xl px-4 py-4 text-left flex items-center justify-between transition-opacity duration-200"
              style={{ animationDelay: `${0.4 * index}s` }}
            >
              <div className="flex items-center gap-3 text-white">
                <span className="text-xl" aria-hidden="true">{section.icon}</span>
                <span className="font-medium">{section.name}</span>
              </div>
              <span className="text-sm text-white/60">{section.questionCountLabel}</span>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => navigate('/assessment/aptitude/test')}
          className="mt-10 rounded-xl bg-gradient-to-r from-amber-500 to-orange-600 px-8 py-3 text-white font-semibold shadow-lg shadow-amber-500/40 aptitude-begin-btn"
        >
          {translateStaticText('Begin Assessment →', currentLanguage)}
        </button>
      </div>
    </div>
  );
}
